import * as React from 'react';
import { Helmet } from 'react-helmet-async';

export interface IBPDocumentTitleProps {
    title: any;
}

export const BPDocumentTitle: React.FunctionComponent<IBPDocumentTitleProps> = (props) => {
    return <Helmet>
        <title>{props.title} - BP Sentry</title>
    </Helmet>;
};
